import { faLock } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Card } from '../ui';
import { Login } from './Login';

export default function SecuredAreaWarning() {
    return (
        <Card>
            <div className="tw-flex tw-items-center tw-justify-center tw-gap-6 tw-border-0 tw-border-b tw-border-solid tw-border-accents-2 tw-pb-4 tw-text-center">
                <FontAwesomeIcon icon={faLock} size="2x" className="tw-text-accents-7" />
                <div>
                    <h2 className="tw-font-semibold">Geschützter Bereich</h2>
                    <h5 className="tw-mb-0 tw-text-accents-8">Logge dich ein um fortzufahren</h5>
                </div>
            </div>
            <Login withReload={false} />
        </Card>
    );
}
